import Button from 'components/button/button';
import './service_card.css';

import React from 'react';
import { Link } from 'react-router-dom';

const ServiceCard = ({
    className = '',
    title,
    link = '#',
    image,
    linkType = '',
}: {
    className?: any;
    title?: any;
    link?: string;
    image?: any;
    linkType?: any;
}) => {
    return (
        <>
            {(linkType && linkType == 'external' && (
                <a
                    href={link}
                    target="_blank"
                    className={`service-card _default ${className}`}
                >
                    {image && (
                        <div
                            className="service-card__image"
                            style={{ backgroundImage: 'url(' + image + ')' }}
                        ></div>
                    )}
                    {title && (
                        <h3
                            className="service-card__title"
                            dangerouslySetInnerHTML={{ __html: title }}
                        ></h3>
                    )}
                    <div className="service-card__button">
                        <Button>Узнать больше</Button>
                    </div>
                </a>
            )) || (
                <Link
                    to={link}
                    className={`service-card _default ${className}`}
                >
                    {image && (
                        <div
                            className="service-card__image"
                            style={{ backgroundImage: 'url(' + image + ')' }}
                        ></div>
                    )}
                    {title && (
                        <h3
                            className="service-card__title"
                            dangerouslySetInnerHTML={{ __html: title }}
                        ></h3>
                    )}
                    <div className="service-card__button">
                        <Button>Узнать больше</Button>
                    </div>
                </Link>
            )}
        </>
    );
};

export default ServiceCard;
